import { render, staticRenderFns } from "./Dinheiro.vue?vue&type=template&id=21f52523"
import script from "./Dinheiro.vue?vue&type=script&lang=js"
export * from "./Dinheiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports